export enum MarketplaceMode
{
    Default = 0,
    Search = 1,
    Category = 2, // e.g. Any lifestyle category
    SubCategory = 3,  // e.g. Service within Automotive
    SpecialCategory = 4, // e.g. "Automotive" with no sub category selected
    OffersNearMe = 5, // e.g. loaded dynamically only if it is selected
}